export type RbacPermission =
  | 'read:dashboard'
  | 'create:programs'
  | 'delete:programs'
  | 'read:programs'
  | 'update:programs'
  | 'create:events'
  | 'delete:events'
  | 'read:events'
  | 'update:events'
  | 'create:notifications'
  | 'delete:notifications'
  | 'read:notifications'
  | 'update:notifications'
  | 'create:users'
  | 'delete:users'
  | 'read:users'
  | 'update:users'
  | 'update:programs__mark_featured'
  | 'read:mission_statements'
  | 'update:assign_church'
  | 'read:donations'
  | 'read:user_requests';

export type RbacRule = {
  static: RbacPermission[];
  dynamic?: {
    [key: string]: (data?: any) => boolean;
  };
};

export const rbacRules = {
  Studier: {
    static: [],
  } as RbacRule,
  'Content Creator': {
    static: [
      'read:dashboard',
      'create:programs',
      'delete:programs',
      'read:programs',
      'update:programs',
      'read:users',
      'read:events',
      'read:notifications',
      'create:notifications',
    ],
  } as RbacRule,
  'Event Leader': {
    static: [
      'read:dashboard',
      'create:events',
      'delete:events',
      'read:events',
      'update:events',
      'read:users',
      'read:programs',
      'read:notifications',
    ],
  } as RbacRule,
  'Church Admin': {
    static: [
      'read:dashboard',
      'create:programs',
      'delete:programs',
      'read:programs',
      'update:programs',
      'create:events',
      'delete:events',
      'read:events',
      'update:events',
      'create:notifications',
      'delete:notifications',
      'read:notifications',
      'update:notifications',
      'create:users',
      'delete:users',
      'read:users',
      'update:users',
      'update:programs__mark_featured',
      'read:mission_statements',
      'read:donations',
      'read:user_requests',
    ],
  } as RbacRule,
  'System Admin': {
    static: [
      'read:dashboard',
      'create:programs',
      'delete:programs',
      'read:programs',
      'update:programs',
      'create:events',
      'delete:events',
      'read:events',
      'update:events',
      'create:notifications',
      'delete:notifications',
      'read:notifications',
      'update:notifications',
      'create:users',
      'delete:users',
      'read:users',
      'update:users',
      'update:programs__mark_featured',
      'read:mission_statements',
      'update:assign_church',
      'read:donations',
      'read:user_requests',
    ],
  } as RbacRule,
};
